import { Button } from '@givebutter/primitives/button';
import { faSave } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as UpdateReportDialog from 'assets/js/pages/reports/UpdateReportDialog';
import { useQueryDiff } from 'assets/js/pages/reports/useQueryDiff';

const UpdateCurrentReportButton = () => {
    const hasDiff = useQueryDiff();

    return (
        <UpdateReportDialog.Root>
            <UpdateReportDialog.Trigger asChild={true}>
                <Button disabled={!hasDiff} variant={'outline'} color={'neutral'}>
                    <FontAwesomeIcon icon={faSave} />
                    Save
                </Button>
            </UpdateReportDialog.Trigger>
        </UpdateReportDialog.Root>
    );
};

export { UpdateCurrentReportButton };
